import { adjustmentSessionIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const undoAdjustmentSession = {
  name: "undoAdjustmentSession" as const,
  input: z.object({ sessionId: adjustmentSessionIdFormat.schema }),
  output: z.object({ success: z.boolean(), pending: z.boolean().optional() }),
};
